import styled from "styled-components";
import { COLORS, FONT_SIZE } from "../../../../constants/Styles";

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
`;

export const Text = styled.div`
  margin: 1rem 0;
  text-align: center;
  color: ${COLORS.secondaryLight};
`;

export const ErrorText = styled.div`
  margin-top: 0.5rem;
  text-align: center;
  color: ${COLORS.error};
  font-size: ${FONT_SIZE.size14};
`;

export const ColumnSelectors = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

export const FileInputs = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: center;
`;

export const FileInputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
